<template>
  <div
    :class="[
      'flex flex-column top',
      isDataCollector ? 'height-auto' : 'height-100',
    ]"
  >
    <div
      :class="[
        'flex flex-column top',
        isDataCollector ? 'height-auto' : 'height-100',
      ]"
    >
      <div
        :class="[
          'flex flex-column top',
          isDataCollector
            ? $style.dataCollectorContainerBody
            : $style.containerBody,
        ]"
      >
        <BaseLoading
          v-if="isGripAnalysisBarriersLoading"
          class="background-white"
        />
        <div v-else>
          <div
            v-for="(item, index) in itemList"
            :key="index"
            :id="'analysis_barrier_' + item.id"
            :class="[
              $style.barrierContainer,
              !isSideBarOpen ? $style.paddingLeftRight8rem : null,
            ]"
          >
            <b-collapse
              :open="true"
              aria-id="contentIdForBarriers"
              class="width-100"
            >
              <template #trigger="props">
                <div
                  :class="[
                    'grip-collapse-container-btn',
                    !props.open ? 'border-bottom-Gray86' : null,
                  ]"
                >
                  <b-icon
                    :icon="!props.open ? 'chevron-down' : 'chevron-up'"
                    size="is-medium"
                  >
                  </b-icon>
                  <a
                    :class="$style.triggerBtn"
                    aria-controls="contentIdForBarriers"
                  >
                    Barrier
                  </a>
                </div>
              </template>

              <div :class="[$style.itemContainer, 'has-position-relative']">
                <div :class="['flex flex-row top', $style.itemBox]">
                  <div>
                    <b :class="$style.title">
                      {{ `${index + 1}. ` }}
                    </b>
                  </div>
                  <div class="flex cell flex-column">
                    <b :class="$style.title">
                      {{ item.title }}
                    </b>
                    <div class="flex flex-row top">
                      <p
                        v-if="item.gripDomainCategory"
                        :class="['margin-right8', $style.categoryBox]"
                      >
                        {{ getUpperCase(item.gripDomainCategory.name) }}
                      </p>
                      <p v-if="item.action" :class="$style.tobeActionedBox">
                        to be actioned
                      </p>
                      <p v-else :class="$style.nottobeActionedBox">
                        Not to be actioned
                      </p>
                    </div>
                    <p :class="$style.description">
                      {{ item.description }}
                    </p>
                  </div>
                  <div v-if="!isDataCollector">
                    <a @click="handleEdit(item)" :class="$style.editBtn">
                      <b-icon icon="pencil" size="is-small" />
                    </a>
                    <a @click="handleDelete(item.id)" :class="$style.deletebtn">
                      <b-icon icon="delete" size="is-small" />
                    </a>
                  </div>
                </div>
                <!-- Conditionally render overlay if this barrier is being edited and modal is minimized -->
                <div
                  v-if="item.id === editingBarrierId && isMinimized"
                  class="shared-list-item-edit-overlay"
                  @click="restoreBarrierModal"
                >
                  <span class="shared-list-item-overlay-text">
                    Resume Edit <i class="mdi mdi-arrow-expand"></i>
                  </span>
                </div>
              </div>
            </b-collapse>
            <GripAnalysisEnablers
              v-if="item.action"
              :projectId="projectId"
              :isDataCollector="isDataCollector"
              :gripAnalysisId="gripAnalysisDetails.id"
              :gripAnalysisBarrierId="item.id"
              :gripAnalysisEnablers="item.gripAnalysisEnablers"
              :updatedItem="updatedItem"
              @addGripAnalysisEnabler="handleAddGripAnalysisEnabler"
              @updateGripAnalysisEnabler="handleUpdateGripAnalysisEnabler"
              @deleteGripAnalysisEnabler="handleDeleteGripAnalysisEnabler"
              @addGripAnalysisStrategy="handleAddGripAnalysisStrategy"
              @updateGripAnalysisStrategy="handleUpdateGripAnalysisStrategy"
              @deleteGripAnalysisStrategy="handleDeleteGripAnalysisStrategy"
              @handleUpdatedItemReload="handleUpdatedItemReload"
            />
          </div>
          <div
            v-if="showBarrierDraggableBox && !isDataCollector"
            :class="[$style.barrierContainer, 'width-100']"
          >
            <b-collapse :open="true" aria-id="contentIdForAddBarriers">
              <template #trigger="props">
                <div :class="['grip-collapse-container-btn']">
                  <b-icon
                    :icon="!props.open ? 'chevron-down' : 'chevron-up'"
                    size="is-medium"
                  >
                  </b-icon>
                  <a
                    :class="$style.triggerBtn"
                    aria-controls="contentIdForAddBarriers"
                  >
                    Barrier
                  </a>
                </div>
              </template>
              <div
                :class="[
                  'flex flex-column top',
                  $style.draggableContainer,
                  'has-position-relative',
                ]"
              >
                <div
                  id="barrierDropZone"
                  @dragover="onDragOver($event)"
                  @drop="onDrop($event, 'barrierDropZone')"
                  :class="['flex flex-column top', $style.labelBox]"
                >
                  <p :class="$style.dragDropContainerText">
                    Drag and drop existing barrier
                  </p>
                  <p :class="$style.dragDropContainerSecondText">
                    or
                    <a @click="openBarrierModal()" :class="$style.addNewItem"
                      >create new</a
                    >
                  </p>
                </div>

                <div
                  v-if="isModalActive && isMinimized && isNew"
                  class="shared-list-item-edit-overlay"
                  @click="restoreBarrierModal"
                >
                  <span class="shared-list-item-overlay-text">
                    Resume Create <i class="mdi mdi-arrow-expand"></i>
                  </span>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!isDataCollector" :class="['flex flex-column top']">
      <div
        :class="[
          $style.addNewContainer,
          !isSideBarOpen ? $style.paddingLeftRight8rem : null,
        ]"
      >
        <button
          :class="['button is-primary', $style.buttonBox]"
          @click="handleShowDraggableBox()"
          :disabled="showBarrierDraggableBox"
        >
          + New Barrier
        </button>
      </div>
    </div>
    <BarrierModal
      v-if="isModalActive"
      :key="modalKey"
      :isModalActive="isModalActive"
      :projectId="projectId"
      :isNew="isNew"
      :draggable="true"
      :gripBarrierDetails="gripBarrierDetailsForEdit"
      :isMinimized="isMinimized"
      @close="closeBarrierModal"
      @create="handleBarrierCreate"
      @update="handleBarrierUpdate"
      @minimize="minimizeBarrierModal"
      @restore="restoreBarrierModal"
    />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import {
  CreateGripAnalysisBarrierPayload,
  CreateGripAnalysisEnablerPayload,
  CreateGripAnalysisStrategyPayload,
  CreateGripBarrierBase,
  GripAnalysisBarrier,
  GripAnalysisDTO,
  GripItemType,
  GripBarrierDTO,
  GripBarrierStatus,
  GripItemReloadDTO,
  UpdateGripAnalysisEnablerPayload,
  UpdateGripAnalysisStrategyPayload,
  UpdateGripBarrierBase,
} from '../../../store/types/grip.types';
import BaseLoading from '../../../components/base/BaseLoading.vue';
import BarrierModal from '../Barrier/BarrierModal.vue';
import DeleteModalBox from '../../../components/DeleteModalBox.vue';
import GripAnalysisEnablers from './GripAnalysisEnablers.vue';
import { namespace } from 'vuex-class';
import { showUnsavedChangesDialog } from '@/utils/dialog.util';

const unsavedChangesGuard = namespace('unsavedChangesGuard');

@Component({
  components: {
    BaseLoading,
    BarrierModal,
    DeleteModalBox,
    GripAnalysisEnablers,
  },
})
export default class GripAnalysisBarriers extends Vue {
  @Prop() public projectId!: number;
  @Prop() public isDataCollector!: boolean;
  @Prop() public isSideBarOpen!: boolean;
  @Prop() public gripAnalysisDetails!: GripAnalysisDTO;
  @Prop() public updatedItem!: GripItemReloadDTO;
  public isGripAnalysisBarriersLoading: boolean = false;
  public showBarrierDraggableBox: boolean = true;
  public itemList: GripAnalysisBarrier[] = [];
  public tempDirtyBarrier: CreateGripBarrierBase = {
    title: '',
    description: '',
    action: true,
    reason: null,
    links: [],
    attachments: [],
    gripDomainCategoryId: null,
  };
  public modalKey: number = Math.floor(Math.random() * 999);
  public isModalActive: boolean = false;
  public isNew: boolean = false;
  public gripBarrierDetailsForEdit: GripBarrierDTO | null = null;
  public isMinimized: boolean = false;

  @unsavedChangesGuard.State('userSelectedKeepEditing')
  public userSelectedKeepEditing!: boolean;

  @unsavedChangesGuard.Action('notifyKeepEditingSelected')
  public notifyKeepEditingSelected!: () => void;

  @unsavedChangesGuard.Action('resetKeepEditingFlag')
  public resetKeepEditingFlag!: () => void;

  get editingBarrierId(): number | null {
    return this.isModalActive && !this.isNew && this.gripBarrierDetailsForEdit
      ? this.gripBarrierDetailsForEdit.id
      : null;
  }

  public getUpperCase(value: string): string {
    return value.toUpperCase();
  }

  public updated(): void {
    if (this.updatedItem.item === GripItemType.AnalysisBarrier) {
      const element = document.getElementById(
        this.updatedItem.item + '_' + this.updatedItem.id,
      );
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    if (this.showBarrierDraggableBox) {
      const element = document.getElementById('contentIdForAddBarriers');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }

  @Watch('gripAnalysisDetails', { deep: true, immediate: true })
  public onGripAnalysisDetailsChanged(): void {
    if (
      this.gripAnalysisDetails &&
      this.gripAnalysisDetails.gripAnalysisBarriers
    ) {
      // Create a new sorted array for itemList to ensure reactivity
      // and to avoid mutating the prop.
      // The barriers are already filtered for ACTIVE status by the parent component (GripAnalysisPane).
      this.itemList = [...this.gripAnalysisDetails.gripAnalysisBarriers].sort(
        (a, b) => a.id - b.id,
      );
    } else {
      this.itemList = [];
    }
    this.showBarrierDraggableBox = this.itemList.length > 0 ? false : true;
  }

  public handleShowDraggableBox(): void {
    this.showBarrierDraggableBox = true;
  }

  public onDragOver(event: any): void {
    const dragSupported = event.dataTransfer.types.length;
    if (dragSupported) {
      event.dataTransfer.dropEffect = 'copy';
      event.preventDefault();
    }
  }

  public onDrop(event: any, id: string): void {
    event.preventDefault();
    const jsonData = event.dataTransfer.getData('application/json');
    const data = JSON.parse(jsonData);
    if (!data) {
      return;
    }

    const { itemType, ...barrierData } = data;
    if (id === 'barrierDropZone' && itemType === 'barrier') {
      const barrierPayload: CreateGripAnalysisBarrierPayload = {
        ...barrierData,
        gripAnalysisId: this.gripAnalysisDetails.id,
      };
      this.$emit('addGripAnalysisBarrier', { barrierPayload, isNew: false });
    }
  }

  private _resetLocalModalState(): void {
    this.isModalActive = false;
    this.isMinimized = false;
    this.gripBarrierDetailsForEdit = null;
    this.isNew = false; // Reset isNew as well
    this.modalKey += 1; // Increment key to re-render modal if needed
  }

  public openBarrierModal(): void {
    this._resetLocalModalState();
    this.isNew = true;
    this.isModalActive = true;
  }

  public handleEdit(barrier: GripAnalysisBarrier): void {
    const {
      gripAnalysisEnablers,
      status,
      createdDate,
      updatedDate,
      ...barrierDetails
    } = barrier;
    this._resetLocalModalState();
    this.gripBarrierDetailsForEdit = barrierDetails as GripBarrierDTO;
    this.isNew = false;
    this.isModalActive = true;
  }

  public async closeBarrierModal(): Promise<void> {
    // The unsaved changes dialog, "Changes discarded" toast, and
    // `notifyKeepEditingSelected` (if user chose to keep editing)
    // are now handled by InteractiveModal before it emits the 'close' event.
    // When this method is called (in response to the @close event
    // from BarrierModal -> InteractiveModal), we can assume it's safe to close
    // and reset local state.
    // The notifyModalClosed() call is also implicitly handled by InteractiveModal
    // when its isModalActive prop (controlled here via _resetLocalModalState)
    // becomes false.
    this._resetLocalModalState();
  }

  public handleBarrierCreate(gripBarrier: CreateGripBarrierBase): void {
    const barrierPayload: CreateGripAnalysisBarrierPayload = {
      ...gripBarrier,
      gripAnalysisId: this.gripAnalysisDetails.id,
    };
    this.$emit('addGripAnalysisBarrier', {
      barrierPayload,
      isNew: true,
    });
    this._resetLocalModalState();
    this.showBarrierDraggableBox = false;
  }

  public minimizeBarrierModal(): void {
    this.isMinimized = true;
  }

  public restoreBarrierModal(): void {
    this.isMinimized = false;
  }

  public handleBarrierUpdate(
    gripBarrierUpdateData: UpdateGripBarrierBase & { id: number },
  ): void {
    // MODIFICATION START: Destructure to check if there are actual changes
    const { id, ...changesToApply } = gripBarrierUpdateData;
    let actualChangesExist = Object.keys(changesToApply).length > 0;

    // If the only "change" is to 'action' but its value hasn't changed from the original,
    // and 'reason' is null/empty (relevant when 'action' is true), it might not be a real change.
    // This part might need more sophisticated deep comparison if complex objects are involved.
    // For now, relying on Object.keys(changesToApply).length is a good first step.
    // A more robust check would involve comparing `gripBarrierUpdateData` with `this.gripBarrierDetailsForEdit`.

    if (this.gripBarrierDetailsForEdit) {
      let hasMeaningfulChange = false;
      for (const key in changesToApply) {
        if (changesToApply.hasOwnProperty(key)) {
          const originalValue = (this.gripBarrierDetailsForEdit as any)[key];
          const newValue = (changesToApply as any)[key];
          if (JSON.stringify(originalValue) !== JSON.stringify(newValue)) {
            // Special handling for 'reason' when 'action' is true
            if (
              key === 'reason' &&
              this.gripBarrierDetailsForEdit.action &&
              (newValue === null || newValue === '')
            ) {
              // If action is true, reason becoming null/empty isn't a change if it was already so
              if (originalValue !== null && originalValue !== '') {
                hasMeaningfulChange = true;
                break;
              }
            } else {
              hasMeaningfulChange = true;
              break;
            }
          }
        }
      }
      actualChangesExist = hasMeaningfulChange;
    }

    if (actualChangesExist) {
      this.$emit('updateGripAnalysisBarrier', {
        ...gripBarrierUpdateData, // Send all data including ID
        gripAnalysisId: this.gripAnalysisDetails.id,
      });
      this.$emit('handleUpdatedItemReload', {
        item: GripItemType.AnalysisBarrier,
        id: gripBarrierUpdateData.id,
        prevItemId: this.getPrevItemId(gripBarrierUpdateData.id),
      });
    }
    // Always close modal and notify, regardless of whether an API call was made.
    this._resetLocalModalState();
  }

  public handleDelete(gripAnalysisBarrierId: number): void {
    this.$buefy.modal.open({
      parent: this,
      component: DeleteModalBox,
      hasModalCard: true,
      trapFocus: true,
      props: {
        modalTitle: 'Delete Barrier?',
        modalContent:
          'Are you sure you want to delete this barrier? This action cannot be undone.',
      },
      events: {
        close: () => {
          this.$emit('close');
        },
        confirm: () => {
          this.$emit('deleteGripAnalysisBarrier', gripAnalysisBarrierId);
          this.$emit('handleUpdatedItemReload', {
            item: GripItemType.AnalysisBarrier,
            id: gripAnalysisBarrierId,
            prevItemId: this.getPrevItemId(gripAnalysisBarrierId),
          });
        },
      },
    });
  }

  public getPrevItemId(gripBarrierId: number): string | null {
    const barrierIndex: number = this.itemList.findIndex(
      (item) => item.id === gripBarrierId,
    );

    return barrierIndex > 0
      ? GripItemType.AnalysisBarrier + '_' + this.itemList[barrierIndex - 1].id
      : null;
  }

  public handleUpdatedItemReload(data: GripItemReloadDTO): void {
    this.$emit('handleUpdatedItemReload', data);
  }

  public handleAddGripAnalysisEnabler(enablerDetails: {
    enablerPayload: CreateGripAnalysisEnablerPayload;
    isNew: boolean;
  }): void {
    this.$emit('addGripAnalysisEnabler', enablerDetails);
  }

  public handleUpdateGripAnalysisEnabler(
    enablerPayload: UpdateGripAnalysisEnablerPayload,
  ): void {
    this.$emit('updateGripAnalysisEnabler', enablerPayload);
  }

  public handleDeleteGripAnalysisEnabler(gripAnalysisEnablerId: number): void {
    this.$emit('deleteGripAnalysisEnabler', gripAnalysisEnablerId);
  }

  public handleAddGripAnalysisStrategy(strategyDetails: {
    strategyPayload: CreateGripAnalysisStrategyPayload;
    isNew: boolean;
  }): void {
    this.$emit('addGripAnalysisStrategy', strategyDetails);
  }

  public handleUpdateGripAnalysisStrategy(
    strategyPayload: UpdateGripAnalysisStrategyPayload,
  ): void {
    this.$emit('updateGripAnalysisStrategy', strategyPayload);
  }

  public handleDeleteGripAnalysisStrategy(
    gripAnalysisStrategyId: number,
  ): void {
    this.$emit('deleteGripAnalysisStrategy', gripAnalysisStrategyId);
  }

  @Watch('userSelectedKeepEditing')
  public onUserSelectedKeepEditing(newValue: boolean): void {
    this.resetKeepEditingFlag();
    if (newValue && this.isMinimized && this.isModalActive) {
      this.restoreBarrierModal();
    }
  }
}
</script>

<style lang="scss" module>
.containerBody {
  width: 100%;
  height: 540px;
  overflow: scroll;
  border-bottom: 1px solid #dbdbdb;
}

.dataCollectorContainerBody {
  width: 100%;
  height: auto;
  overflow: scroll;
  border-bottom: 1px solid #dbdbdb;
}

.barrierContainer {
  width: 100%;
  padding: 1.5rem 2.5rem;
  border-bottom: 1px solid #dbdbdb;
}

.paddingLeftRight8rem {
  padding-left: 8rem !important;
  padding-right: 8rem !important;
}

.triggerBtn {
  background: none;
  border: none;
  padding: 10px 0px 0px 0px;
  margin-left: unset;
  font-weight: 400;
  font-size: 14px;
  color: #444f51;

  &:focus {
    box-shadow: none;
    border: none;
  }

  &:hover,
  &:active {
    border: none;
  }
}

.draggableContainer {
  justify-content: center;
  align-items: center;
  padding: 36px 20px;
  background: #fbfbfb;
  border: 1px dashed #9f9f9f;
  border-radius: 6px;
  box-sizing: border-box;

  .labelBox {
    align-items: center;

    .dragDropContainerText {
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 700;
      font-size: 18px;
      line-height: 22px;
      color: #9f9f9f;
      margin-bottom: 0.5rem;
    }

    .dragDropContainerSecondText {
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      color: #444f51;
    }
  }
}

.itemContainer {
  margin-bottom: 1rem;
}

.itemBox {
  padding: 16px;
  background: #ffffff;
  border: 1px solid #dbdbdb;
  border-radius: 4px;
  box-sizing: border-box;

  .title {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    color: #444f51;
    margin-bottom: 0.5rem;
    margin-right: 0.5rem;
    max-width: 70ch;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .categoryBox {
    font-size: 10px;
    font-weight: 600;
    line-height: 14px;
    background: #e6ecf6;
    border-radius: 4px;
    margin-bottom: 0.5rem;
    color: #444f51;
    width: fit-content;
    padding: 2px 4px;
  }

  .tobeActionedBox {
    font-size: 10px;
    font-weight: 600;
    line-height: 14px;
    background: #e6ecf6;
    border-radius: 4px;
    margin-bottom: 0.5rem;
    text-transform: uppercase;
    color: #21b5ea;
    width: fit-content;
    padding: 2px 4px;
  }

  .nottobeActionedBox {
    font-size: 10px;
    font-weight: 600;
    line-height: 14px;
    background: rgba(255, 151, 0, 0.1);
    border-radius: 4px;
    margin-bottom: 0.5rem;
    text-transform: uppercase;
    color: #ff9700;
    width: fit-content;
    padding: 2px 4px;
  }

  .description {
    max-width: 70ch;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-right: 0.5rem;
  }

  .editBtn {
    color: #21b5ea;
    padding-right: 12px;
  }
  .deletebtn {
    color: #21b5ea;
  }
}

.addNewItem {
  color: #00205b;
  font-weight: bold;
  font-size: 14px;
}

.addNewContainer {
  width: 100%;
  padding: 1rem 2.5rem;
  margin-left: 0;
  margin-right: 0;

  .buttonBox {
    width: 100%;
    line-height: 18px;
    font-size: 16px;
    font-weight: 600;
  }
}
</style>
